import { useEffect } from 'react'
import { StytchB2B } from '@stytch/react/b2b'
import { useStytchMember } from '@stytch/react/b2b'
import { B2BOAuthProviders, B2BProducts, StytchB2BUIConfig } from '@stytch/vanilla-js'

const Login = () => {
    const { member, isInitialized } = useStytchMember()

    useEffect(() => {
        if (isInitialized && member) {
            // Use hard redirect to ensure fresh page load
            window.location.replace('/')
        }
    }, [isInitialized, member])
    const config: StytchB2BUIConfig = {
        authFlowType: 'Discovery',
        products: [B2BProducts.emailOtp, B2BProducts.emailMagicLinks, B2BProducts.oauth],
        emailMagicLinksOptions: {
            discoveryRedirectURL: `${window.location.origin}/login`,
        },
        oauthOptions: {
            discoveryRedirectURL: `${window.location.origin}/login`,
            providers: [{ type: B2BOAuthProviders.Google }],
        },
        sessionOptions: {
            sessionDurationMinutes: 10080, // 1 week
        },
    }

    const styles = {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
        primaryColor: '#282c34',
        primaryTextColor: '#ffffff',
        hideHeaderText: true,
    }

    const callbacks = {
        onEvent: ({ type, data }: { type: string; data: any }) => {
            if (import.meta.env.MODE === 'dev' || import.meta.env.DEV) {
                console.log('Stytch event:', type, data)
            }

            // Redirect to home after successful authentication
            if (type === 'AUTHENTICATED') {
                window.location.href = '/'
            }
        },
        onError: (error: any) => {
            console.error('Stytch error:', error)
        },
    }

    const strings = {
        discoveryEmailOrganizationsCTA: 'Continue',
    }

    return (
        <div className="flex justify-center items-center min-h-[calc(100vh-200px)] p-8">
            <div className="bg-white rounded-xl shadow-md p-12 max-w-[500px] w-full [&_a[href*='stytch.com']]:hidden">
                <div className="mb-8">
                    <h1 className="text-[#282c34] mb-2 text-center text-2xl">Sign In to Your Organization</h1>
                    <p className="text-[#666] text-center text-sm leading-relaxed">
                        Enter your work email to receive a magic link. All users from your domain will have access to
                        the same organization.
                    </p>
                </div>

                <StytchB2B config={config} styles={styles} callbacks={callbacks} strings={strings} />
            </div>
        </div>
    )
}

export default Login
